var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmptyState = function SvgEmptyState(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 28V23C15 22.448 15.448 22 16 22H21L15 28Z",
    fill: "url(#paint0_linear_364_9078)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57 18C57 11.383 51.617 6 45 6C38.383 6 33 11.383 33 18H14C12.346 18 11 19.346 11 21V22H9C7.897 22 7 22.897 7 24V52C7 53.103 7.897 54 9 54H11V55C11 56.654 12.346 58 14 58H42C43.654 58 45 56.654 45 55V54H47C48.103 54 49 53.103 49 52V29.3C53.653 27.647 57 23.213 57 18ZM9 52V24H11V52H9ZM42 56H14C13.448 56 13 55.552 13 55V21C13 20.448 13.448 20 14 20H33V30H43V55C43 55.552 42.552 56 42 56ZM47 52H45V30C45.683 30 46.348 29.929 47 29.819V52ZM45 28H35V18C35 12.486 39.486 8 45 8C50.514 8 55 12.486 55 18C55 23.514 50.514 28 45 28Z",
    fill: "url(#paint1_linear_364_9078)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 52H38V54H34V52Z",
    fill: "url(#paint2_linear_364_9078)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26 52H30V54H26V52Z",
    fill: "url(#paint3_linear_364_9078)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 52H22V54H18V52Z",
    fill: "url(#paint4_linear_364_9078)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 33,
    width: 2.5,
    height: 5,
    fill: "url(#paint5_linear_364_9078)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 33,
    width: 2.5,
    height: 5,
    fill: "url(#paint6_linear_364_9078)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8633 17.1484V18.8711C47.8633 19.6185 47.7835 20.2633 47.624 20.8057C47.4645 21.3434 47.2344 21.7855 46.9336 22.1318C46.6374 22.4736 46.2842 22.7266 45.874 22.8906C45.4639 23.0547 45.0081 23.1367 44.5068 23.1367C44.1058 23.1367 43.7321 23.0866 43.3857 22.9863C43.0394 22.8815 42.7272 22.7197 42.4492 22.501C42.1758 22.2822 41.9388 22.0065 41.7383 21.6738C41.5423 21.3366 41.3919 20.9355 41.2871 20.4707C41.1823 20.0059 41.1299 19.4727 41.1299 18.8711V17.1484C41.1299 16.401 41.2096 15.7607 41.3691 15.2275C41.5332 14.6898 41.7633 14.25 42.0596 13.9082C42.3604 13.5664 42.7158 13.3158 43.126 13.1562C43.5361 12.9922 43.9919 12.9102 44.4932 12.9102C44.8942 12.9102 45.2656 12.9626 45.6074 13.0674C45.9538 13.1676 46.266 13.3249 46.5439 13.5391C46.8219 13.7533 47.0589 14.029 47.2549 14.3662C47.4508 14.6989 47.6012 15.0977 47.7061 15.5625C47.8109 16.0228 47.8633 16.5514 47.8633 17.1484ZM45.8877 19.1309V16.8818C45.8877 16.5218 45.8672 16.2074 45.8262 15.9385C45.7897 15.6696 45.7327 15.4417 45.6553 15.2549C45.5778 15.0635 45.4821 14.9085 45.3682 14.79C45.2542 14.6715 45.1243 14.585 44.9785 14.5303C44.8327 14.4756 44.6709 14.4482 44.4932 14.4482C44.2699 14.4482 44.0716 14.4915 43.8984 14.5781C43.7298 14.6647 43.5863 14.8037 43.4678 14.9951C43.3493 15.182 43.2581 15.4326 43.1943 15.7471C43.1351 16.057 43.1055 16.4352 43.1055 16.8818V19.1309C43.1055 19.4909 43.1237 19.8076 43.1602 20.0811C43.2012 20.3545 43.2604 20.5892 43.3379 20.7852C43.4199 20.9766 43.5156 21.1338 43.625 21.2568C43.7389 21.3753 43.8688 21.4619 44.0146 21.5166C44.165 21.5713 44.3291 21.5986 44.5068 21.5986C44.7256 21.5986 44.9193 21.5553 45.0879 21.4688C45.2611 21.3776 45.4069 21.2363 45.5254 21.0449C45.6484 20.849 45.7396 20.5938 45.7988 20.2793C45.8581 19.9648 45.8877 19.582 45.8877 19.1309Z",
    fill: "url(#paint7_linear_364_9078)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3315 41.498C31.4395 43.041 29.7805 43.999 28.0005 43.999C26.2225 43.999 24.5625 43.041 23.6695 41.5L21.9395 42.502C23.1875 44.659 25.5115 45.999 28.0005 45.999C30.4925 45.999 32.8155 44.658 34.0635 42.5L32.3315 41.498Z",
    fill: "url(#paint8_linear_364_9078)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_364_9078",
    x1: 18,
    y1: 21.667,
    x2: 18,
    y2: 28.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AB4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E492FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_364_9078",
    x1: 32,
    y1: 4.5,
    x2: 32,
    y2: 59.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A6DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9529B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_364_9078",
    x1: 36,
    y1: 4.5,
    x2: 36,
    y2: 59.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A6DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C822FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_364_9078",
    x1: 28,
    y1: 4.5,
    x2: 28,
    y2: 59.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A6DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C822FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_364_9078",
    x1: 20,
    y1: 4.5,
    x2: 20,
    y2: 59.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A6DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C822FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_364_9078",
    x1: 23.2501,
    y1: -1.42104,
    x2: 23.2501,
    y2: 62.7423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A6DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C822FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_364_9078",
    x1: 32.2501,
    y1: -1.42104,
    x2: 32.2501,
    y2: 62.7423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A6DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C822FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_364_9078",
    x1: 44.5005,
    y1: -100.147,
    x2: 44.5005,
    y2: 105.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A6DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C822FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_364_9078",
    x1: 28.0015,
    y1: 4.49905,
    x2: 28.0015,
    y2: 59.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A6DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C822FF"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyState);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "empty-state.f4326cd071d68c792a53b5f707c04006.svg";